"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../../../utils/utils");
var _analytics = _interopRequireDefault(require("../entel/analytics"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class AnalyticsServicePE extends _analytics.default {
  startJourney() {
    console.log('Peru Journey started ....');
  }
  getRoamingTaggingData(_ref) {
    let {
      selectedOptions
    } = _ref;
    return selectedOptions.map(s => typeof s === 'string' ? (0, _utils.replaceSpanishCharacter)(s.toLowerCase()) : s)[0];
  }
  _getProductData(product, costs, flags) {
    const productData = super._getProductData(product, costs, flags);
    if (!productData) return {};
    if ((product === null || product === void 0 ? void 0 : product.productType) === 'plan') {
      productData.product_price = costs === null || costs === void 0 ? void 0 : costs.totalTermCost;
      productData.product_subprice = costs === null || costs === void 0 ? void 0 : costs.totalTermCostAfterDiscount;
    }
    return productData;
  }
}
var _default = AnalyticsServicePE;
exports.default = _default;